import { CodeBlock ,dracula } from 'react-code-blocks';
import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCopy , faDownload} from '@fortawesome/free-solid-svg-icons';

function CodeExport(props) {
    
    const code = `// SPDX-License-Identifier: MIT
// Created By: https://altcoinator.com
    
    pragma solidity ^0.6.0;
    
    interface IBEP20 {
      function totalSupply() external view returns (uint256);
      function decimals() external view returns (uint8);
      function symbol() external view returns (string memory);
      function name() external view returns (string memory);
      function getOwner() external view returns (address);
      function balanceOf(address account) external view returns (uint256);
      function transfer(address recipient, uint256 amount) external returns (bool);
      function allowance(address _owner, address spender) external view returns (uint256);
      function approve(address spender, uint256 amount) external returns (bool);
      function transferFrom(address sender, address recipient, uint256 amount) external returns (bool);
      event Transfer(address indexed from, address indexed to, uint256 value);
      event Approval(address indexed owner, address indexed spender, uint256 value);
    }
     
    contract Context {
     
      constructor () internal { }
    
      function _msgSender() internal view returns (address payable) {
        return msg.sender;
      }
    
      function _msgData() internal view returns (bytes memory) {
        this; // silence state mutability warning without generating bytecode - see https://github.com/ethereum/solidity/issues/2691
        return msg.data;
      }
    }
    
    
    library SafeMath {
     
      function add(uint256 a, uint256 b) internal pure returns (uint256) {
        uint256 c = a + b;
        require(c >= a, "SafeMath: addition overflow");
    
        return c;
      }
     
      function sub(uint256 a, uint256 b) internal pure returns (uint256) {
        return sub(a, b, "SafeMath: subtraction overflow");
      }
     
      function sub(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b <= a, errorMessage);
        uint256 c = a - b;
    
        return c;
      }
     
      function mul(uint256 a, uint256 b) internal pure returns (uint256) {
     
        if (a == 0) {
          return 0;
        }
    
        uint256 c = a * b;
        require(c / a == b, "SafeMath: multiplication overflow");
    
        return c;
      }
    
      function div(uint256 a, uint256 b) internal pure returns (uint256) {
        return div(a, b, "SafeMath: division by zero");
      }
    
      function div(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        // Solidity only automatically asserts when dividing by 0
        require(b > 0, errorMessage);
        uint256 c = a / b;
        // assert(a == b * c + a % b); // There is no case in which this doesn't hold
    
        return c;
      }
    
      function mod(uint256 a, uint256 b) internal pure returns (uint256) {
        return mod(a, b, "SafeMath: modulo by zero");
      }
    
      function mod(uint256 a, uint256 b, string memory errorMessage) internal pure returns (uint256) {
        require(b != 0, errorMessage);
        return a % b;
      }
    }

    contract Ownable is Context {
  address private _owner;

  event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);

  constructor () internal {
    address msgSender = _msgSender();
    _owner = msgSender;
    emit OwnershipTransferred(address(0), msgSender);
  }

  function owner() public view returns (address) {
    return _owner;
  }

  modifier onlyOwner() {
    require(_owner == _msgSender(), "Ownable: caller is not the owner");
    _;
  }

  function renounceOwnership() public onlyOwner {
    emit OwnershipTransferred(_owner, address(0));
    _owner = address(0);
  }

  function transferOwnership(address newOwner) public onlyOwner {
    _transferOwnership(newOwner);
  }

  function _transferOwnership(address newOwner) internal {
    require(newOwner != address(0), "Ownable: new owner is the zero address");
    emit OwnershipTransferred(_owner, newOwner);
    _owner = newOwner;
  }
}
    
    contract AltcoinatorStandardToken is Context, IBEP20, Ownable {
      using SafeMath for uint256;
    
      mapping (address => uint256) private _balances;
      mapping (address => mapping (address => uint256)) private _allowances;
    
    
      event OwnershipTransferred(address indexed previousOwner, address indexed newOwner);
    
      uint256 private _totalSupply;
      uint8 private _decimals;
      string private _symbol;
      string private _name;
      bool private _initialized;
    
      constructor() public {
        _name = '${props.name}';
      _symbol = '${props.symbol}';
      _decimals = ${props.decimal};
      _totalSupply = ${props.supply} * (10**${props.decimal});  
      _balances[msg.sender] = _totalSupply;
  
      emit Transfer(address(0), msg.sender, _totalSupply);
    }
    
    
     function getOwner() external override view returns (address) {
        return owner();
      }
    
      function decimals() external override view returns (uint8) {
        return _decimals;
      }
    
      function symbol() external override view returns (string memory) {
        return _symbol;
      }
    
      function name() external override view returns (string memory) {
        return _name;
      }
    
      function totalSupply() external override view returns (uint256) {
        return _totalSupply;
      }
    
      function balanceOf(address account) external override view returns (uint256) {
        return _balances[account];
      }
    
      function transfer(address recipient, uint256 amount) external override returns (bool) {
        _transfer(_msgSender(), recipient, amount);
        return true;
      }
    
      function allowance(address owner, address spender) external override view returns (uint256) {
        return _allowances[owner][spender];
      }
    
      function approve(address spender, uint256 amount) external override returns (bool) {
        _approve(_msgSender(), spender, amount);
        return true;
      }
    
      function transferFrom(address sender, address recipient, uint256 amount) external override returns (bool) {
        _transfer(sender, recipient, amount);
        _approve(sender, _msgSender(), _allowances[sender][_msgSender()].sub(amount, "BEP20: transfer amount exceeds allowance"));
        return true;
      }
    
      function increaseAllowance(address spender, uint256 addedValue) public returns (bool) {
        _approve(_msgSender(), spender, _allowances[_msgSender()][spender].add(addedValue));
        return true;
      }
    
      function decreaseAllowance(address spender, uint256 subtractedValue) public returns (bool) {
        _approve(_msgSender(), spender, _allowances[_msgSender()][spender].sub(subtractedValue, "BEP20: decreased allowance below zero"));
        return true;
      }
    
      function _transfer(address sender, address recipient, uint256 amount) internal {
        require(sender != address(0), "BEP20: transfer from the zero address");
        require(recipient != address(0), "BEP20: transfer to the zero address");
    
        _balances[sender] = _balances[sender].sub(amount, "BEP20: transfer amount exceeds balance");
        _balances[recipient] = _balances[recipient].add(amount);
        emit Transfer(sender, recipient, amount);
      }
    
      function _burn(address account, uint256 amount) internal {
        require(account != address(0), "BEP20: burn from the zero address");
    
        _balances[account] = _balances[account].sub(amount, "BEP20: burn amount exceeds balance");
        _totalSupply = _totalSupply.sub(amount);
        emit Transfer(account, address(0), amount);
      }
    
      function _approve(address owner, address spender, uint256 amount) internal {
        require(owner != address(0), "BEP20: approve from the zero address");
        require(spender != address(0), "BEP20: approve to the zero address");
    
        _allowances[owner][spender] = amount;
        emit Approval(owner, spender, amount);
      }
    
      function _burnFrom(address account, uint256 amount) internal {
        _burn(account, amount);
        _approve(account, _msgSender(), _allowances[account][_msgSender()].sub(amount, "BEP20: burn amount exceeds allowance"));
      }
    
    }`;


    const downloadCode = () => {
      const element = document.createElement("a");
      const file = new Blob([code], {type: 'text/plain'});
      element.href = URL.createObjectURL(file);
      element.download = "Altcoinator"+props.name+".sol";
      document.body.appendChild(element); // Required for this to work in Firefox
      element.click();
    }

 
     return ( 
      <div className='mb-3'>

        <div className='row mb-3'>

        <div className='col-lg-3'>
              
          </div>
          <div className='col-lg-3'>
              
              </div>

          <div className='col-lg-3'>
              <button type="button"  onClick={()=>{navigator.clipboard.writeText(code); toast.success("Code Copied")}} className="tf-button style2 w-100">
                  <FontAwesomeIcon icon={faCopy} style={{marginRight:"5px"}} /> Copy 
              </button>
          </div>

          <div className='col-lg-3'>
              <button type="button"  onClick={downloadCode} className="tf-button style2 w-100">
                  <FontAwesomeIcon icon={faDownload} style={{marginRight:"5px"}} /> Download 
              </button>
          </div>

        </div>
 
          <CodeBlock
          text={code}
          language={"js"}
          showLineNumbers={true}
          theme={dracula}
        />
          
       </div>
     
      ); 

} 

export default CodeExport;